// const LinkHead = "";
const LinkHead = "/api/";

export const CREATE_URL = `${LinkHead}/lodges`;
export const GETALLLODGES_URL = `${LinkHead}/lodges/getLodges?limit=5000`;
export const LOGIN_URL = `${LinkHead}/users/login`;
export const SIGNUP_URL = `${LinkHead}/users/register`;
export const CREATE_SUGGEST_LODGE_URL = `${LinkHead}/suggestlodges`;
export const DELETE_SUGGEST_LODGE_URL = `${LinkHead}/suggestlodges`;
export const UPDATE_SUGGEST_LODGE_URL = `${LinkHead}/suggestlodges/updateSuggestedLodge`;
export const UPDATE_URL = `${LinkHead}/lodges/update/`;
export const UPDATE_LODGE_IMAGES = `${LinkHead}/updateLodgeImages/`;
export const GET_LODGES_BY_TOWN = `${LinkHead}/lodges/getLodgesByTown?town=`;
export const GET_LODGES_WITH_PAGENUM = `${LinkHead}/lodges/getLodges?page=`;
export const DELETE_URL = `${LinkHead}/lodges`;
